export default __webpack_public_path__ + "static/media/brownarrow.bf279ac9.svg";